export enum ButtonTypes {
  DEFAULT = 'DEFAULT',
  OUTLINE = 'OUTLINE',
  SECONDARY = 'SECONDARY',
  ICON = 'ICON'
}
